var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyBody(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.93,
    height: 44.93,
    viewBox: "0 0 42.93 44.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "MyBody",
    d: "M54.5,54.04H17.49a3.034,3.034,0,0,1-3.03-3.03V46.68L22,27.92c.45-1.11.83-1.27.83-1.28.02.01.4.2.76,1.34l4.49,14.05c.69,2.16,1.72,2.63,2.47,2.65.73.04,1.8-.41,2.59-2.54l3.54-9.62c.37-1,.82-1.38,1.09-1.4s.77.29,1.27,1.23l2.26,4.2c1.11,2.05,2.41,2.28,3.09,2.23s1.93-.46,2.73-2.65l6.29-17.3a.959.959,0,0,0-1.8-.66l-6.29,17.3c-.36,1-.81,1.38-1.07,1.4-.29.02-.76-.29-1.27-1.23l-2.26-4.2c-1.11-2.05-2.41-2.28-3.09-2.23s-1.94.46-2.75,2.64l-3.54,9.62a3.863,3.863,0,0,1-.71,1.3c-.09-.04-.42-.36-.73-1.33L25.41,27.39c-.69-2.15-1.74-2.64-2.5-2.67s-1.84.38-2.69,2.48L14.45,41.55V11.99a.96.96,0,0,0-1.92,0V51.01a4.955,4.955,0,0,0,4.95,4.95H54.5a.96.96,0,0,0,0-1.92Z",
    transform: "translate(-12.53 -11.03)",
    fill: "#d1d7ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBody);
export default __webpack_public_path__ + "static/media/MyBody.7fb723c695679235bf807521b5c09e56.svg";
export { ForwardRef as ReactComponent };